import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { getRecycleOrderConsignmentAgreement } from 'apis/oms';
import { OMS_RECYCLE_ORDER_TYPE_MAP } from 'commons/options';
import LOCALS from 'commons/locals';
import i18n from '../../../i18n';
import { isJapanReceptionStore } from './reception-form/options';

const ConsignmentAgreementEntry = ({
  orderId,
  storeId,
  submissionId,
  orderType,
}: {
  orderId: string;
  storeId?: number;
  submissionId?: number;
  orderType?: number;
}) => {
  const [signed, setSigned] = useState<boolean | undefined>();
  const visible =
    Boolean(submissionId) &&
    isJapanReceptionStore(storeId) &&
    orderType === OMS_RECYCLE_ORDER_TYPE_MAP.CONSIGNMENT;

  useEffect(() => {
    if (!visible || !submissionId) {
      setSigned(undefined);
      return;
    }

    let active = true;
    getRecycleOrderConsignmentAgreement(submissionId)
      .then((res) => {
        if (!active) return;
        setSigned(Boolean(res.signed));
      })
      .catch(() => {
        if (!active) return;
        setSigned(false);
      });

    return () => {
      active = false;
    };
  }, [submissionId, visible]);

  if (!visible || signed === undefined) return null;

  return (
    <Link
      to={`/rrs/consignment-agreement/${submissionId}`}
      state={{ from: `/rrs/recycling-consignment-detail/${orderId}` }}
    >
      <Button type={signed ? 'default' : 'primary'}>
        {i18n.t(
          signed
            ? LOCALS.view_consignment_agreement
            : LOCALS.sign_consignment_agreement,
        )}
      </Button>
    </Link>
  );
};

export default ConsignmentAgreementEntry;
